import { Epic, ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { actions } from '.';
import { addErrorNotice, callApi, catchWithAuthErrors } from 'Data/Helpers/rxjsHelpers';
import webApi from 'Lib/WebApi';
import { of } from 'rxjs';

export const init: Epic = (action$) =>
  action$.pipe(
    ofType(actions.init.toString()),
    mergeMap(({ payload: { revisionId = null } }) =>
      callApi(webApi.ags.revision.errors.get({ revisionId })).pipe(
        mergeMap((response) => of(actions.initResolve(response.Body))),
        catchWithAuthErrors((err: any) =>
          of(actions.initReject(), addErrorNotice('Failed to get Validation Error Messsages.', err))
        )
      )
    )
  );
